import { render } from "./MoveToProcessing.vue?vue&type=template&id=7992272b"
import script from "./MoveToProcessing.vue?vue&type=script&lang=js"
export * from "./MoveToProcessing.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__